export default function authHeader() {
    let token = localStorage.getItem('token') || null;

    if(token !== null){
        return (token !== undefined) ? token : '';
    }else{
        return {};
    }
}
